export const ko = {
  nav: {
    home: '홈',
    about: '회사소개',
    hybrid: '하이브리드 워크포스',
    businesses: '사업부문',
    solutions: '솔루션',
    insights: '인사이트',
    careers: '채용',
    contact: '문의하기'
  },
  home: {
    hero: {
      title: '우리는 일의 미래를 설계합니다.',
      human: '인간 지능',
      ai: 'AI 최적화',
      robotics: '로봇 실행'
    },
    philosophy: {
      headline: '하이브리드 워크포스는 자동화가 아닙니다. 아키텍처입니다.',
      body: '우리는 인간, AI, 로봇을 단일 워크포스 아키텍처로 통합하여 일의 미래를 설계합니다. 이것은 사람을 대체하는 것이 아니라, 각자의 강점을 최대한 활용하여 더 나은 업무 환경을 만드는 것입니다.'
    },
    businesses: {
      manpower: {
        label: '인간 핵심',
        title: 'Manpower',
        description: '글로벌 인력 솔루션의 선두주자로서, 전략적 판단과 책임이 필요한 업무에 최고의 인재를 연결합니다.'
      },
      ai: {
        label: '인텔리전스 레이어',
        title: 'AI Layer',
        description: '예측, 최적화, 의사결정 지원을 통해 인간과 로봇 워크포스를 연결하는 지능형 시스템입니다.'
      },
      robotics: {
        label: '로봇 핵심',
        title: 'BC Robotics',
        description: '반복적이고 정밀한 작업을 위한 첨단 로봇 솔루션으로 운영 효율성을 극대화합니다.'
      }
    },
    cta: {
      headline: '워크포스를 재설계할 준비가 되셨나요?',
      subtext: '엔터프라이즈 고객을 위한 맞춤형 하이브리드 워크포스 솔루션을 제공합니다.',
      button: '대화 시작하기'
    }
  },
  about: {
    opening: {
      headline: '우리는 일이 대체되는 것이 아니라\n재설계되어야 한다고 믿습니다',
      team: '워크포스 아키텍트가 이끄는 팀, 기술자가 아닙니다'
    },
    vision: {
      why: {
        title: '우리가 존재하는 이유',
        content: '전통적인 노동 모델은 한계에 도달했습니다. 우리는 인간의 판단력, AI의 지능, 로봇의 정밀성을 결합하여 더 효율적이고 인간적인 업무 환경을 만듭니다. BrainCommerce는 단순히 기술을 제공하는 것이 아니라, 일하는 방식 자체를 재정의합니다.'
      },
      broken: {
        title: '낡은 노동 모델',
        content: '기존의 노동 시장은 인간만으로, 또는 기술만으로 문제를 해결하려 했습니다. 하지만 진정한 혁신은 이 둘의 조화에서 나옵니다. 우리는 각 요소가 가장 잘할 수 있는 일에 집중하도록 워크포스를 설계합니다.'
      },
      manifesto: '"우리는 사람을 대체하지 않습니다. 우리는 사람이 더 의미 있는 일을 할 수 있도록 시스템을 재설계합니다. 이것이 하이브리드 워크포스의 본질입니다."'
    }
  },
  hybrid: {
    hero: {
      title: 'Hybrid Workforce',
      definition: '하이브리드 워크포스는 인간, AI, 로봇이 각자의 강점을 발휘하며 협력하는 통합 워크포스 아키텍처입니다.',
      human: '인간',
      ai: 'AI',
      robotics: '로봇'
    },
    roles: {
      human: {
        title: '인간',
        point1: '전략적 판단과 의사결정',
        point2: '복잡한 문제 해결',
        point3: '창의성과 혁신',
        point4: '책임과 윤리적 감독'
      },
      ai: {
        title: 'AI',
        point1: '데이터 분석 및 예측',
        point2: '프로세스 최적화',
        point3: '패턴 인식 및 학습',
        point4: '실시간 의사결정 지원'
      },
      robotics: {
        title: '로봇',
        point1: '반복적 작업 수행',
        point2: '정밀한 물리적 실행',
        point3: '24/7 운영 가능',
        point4: '위험 환경 작업'
      },
      learnMore: '자세히 알아보기'
    },
    diagram: {
      title: '하이브리드 워크포스 프로세스',
      task: '작업',
      human: '인간',
      humanRole: '판단',
      ai: 'AI',
      aiRole: '최적화',
      robotics: '로봇',
      roboticsRole: '실행',
      result: '결과'
    }
  },
  businesses: {
    overview: {
      title: '우리의 생태계',
      description: 'BrainCommerce는 세 가지 핵심 요소로 구성된 통합 생태계입니다. Manpower는 인간 워크포스를, BC Robotics는 로봇 워크포스를, 그리고 AI Layer는 이 모든 것을 연결합니다.',
      manpower: 'Manpower',
      aiLayer: 'AI Layer',
      robotics: 'BC Robotics'
    },
    manpower: {
      title: 'Manpower: 인간 워크포스 핵심',
      description: '70년 이상의 역사를 가진 글로벌 인력 솔루션 리더입니다. 우리는 전략적 사고와 책임이 필요한 역할에 최고의 인재를 연결합니다.',
      service1: '글로벌 인재 채용 및 배치',
      service2: '워크포스 컨설팅 및 전략',
      service3: '인재 개발 및 교육',
      service4: '조직 설계 및 최적화',
      cta: 'Manpower 알아보기'
    },
    ai: {
      title: 'AI Layer: 인텔리전스 연결',
      description: '인간과 로봇 워크포스를 연결하는 지능형 시스템입니다. 예측, 최적화, 실시간 의사결정 지원을 통해 전체 워크포스의 효율성을 극대화합니다.',
      service1: '워크포스 분석 및 예측',
      service2: '작업 할당 최적화',
      service3: '성과 모니터링 및 개선',
      service4: '지능형 자동화 시스템',
      cta: 'AI 솔루션 알아보기'
    },
    robotics: {
      title: 'BC Robotics: 로봇 워크포스 핵심',
      description: '반복적이고 정밀한 작업을 위한 첨단 로봇 솔루션을 제공합니다. 물류, 제조, 서비스 산업에서 운영 효율성을 혁신합니다.',
      service1: '자율 이동 로봇 (AMR)',
      service2: '협동 로봇 (Cobot)',
      service3: '로봇 프로세스 자동화',
      service4: '스마트 물류 시스템',
      cta: 'BC Robotics 알아보기'
    },
    maintenance: {
      title: '유지보수 및 서비스: 운영 우수성',
      description: '로봇 및 스마트 팩토리 장비를 위한 종합 유지보수 및 서비스 솔루션입니다. 자동화 시스템의 최대 가동 시간과 최적의 성능을 보장합니다.',
      service1: '예방 정비 및 점검',
      service2: '긴급 수리 및 기술 지원',
      service3: '장비 업그레이드 및 최적화',
      service4: '원격 모니터링 및 진단',
      cta: '유지보수 서비스 알아보기'
    }
  },
  solutions: {
    tabs: {
      hr: 'HR 리더를 위한',
      ceo: 'CEO를 위한',
      industry: '산업별'
    },
    hr: {
      challenge: '워크포스 설계의 새로운 패러다임',
      benefit1: '작업 기반 워크포스 설계',
      benefit2: '인재 최적화 및 배치',
      benefit3: '미래 역량 개발',
      case1: {
        company: '글로벌 제조 기업',
        challenge: '숙련 인력 부족과 높은 이직률로 생산성 저하',
        solution: '하이브리드 워크포스 모델 도입으로 반복 작업은 로봇에, 품질 관리는 인간에 할당',
        result: '생산성 40% 증가, 이직률 25% 감소',
        metric: '생산성 증가'
      },
      case2: {
        company: '물류 서비스 기업',
        challenge: '계절별 수요 변동에 대응하는 유연한 워크포스 필요',
        solution: 'AI 기반 수요 예측과 하이브리드 워크포스로 피크 시즌 대응',
        result: '운영 비용 60% 절감, 배송 시간 단축',
        metric: '비용 절감'
      },
      case3: {
        company: '서비스 산업 기업',
        challenge: '고객 서비스 품질 유지하면서 운영 효율성 개선 필요',
        solution: '루틴 작업은 자동화하고 인간은 고객 관계에 집중',
        result: '고객 만족도 3배 증가, 직원 만족도 향상',
        metric: '고객 만족도'
      }
    },
    ceo: {
      challenge: '지속 가능한 성장을 위한 전략',
      benefit1: '확장 가능한 워크포스 모델',
      benefit2: '운영 비용 최적화',
      benefit3: '경쟁 우위 확보',
      case1: {
        company: '중견 제조 기업',
        challenge: '글로벌 확장을 위한 워크포스 확장 필요',
        solution: '하이브리드 워크포스로 빠른 확장과 품질 유지 동시 달성',
        result: '연간 250만 달러 비용 절감',
        metric: '연간 절감'
      },
      case2: {
        company: '이커머스 기업',
        challenge: '급격한 성장에 따른 물류 병목 현상',
        solution: 'AI와 로봇 기반 물류 시스템으로 처리 용량 확대',
        result: '처리 용량 200% 증가',
        metric: '용량 증가'
      },
      case3: {
        company: '헬스케어 기업',
        challenge: '규제 준수와 효율성 개선의 균형',
        solution: '인간은 의사결정과 감독에, 로봇은 정밀 작업에 집중',
        result: '규제 준수율 85% 향상',
        metric: '준수율'
      }
    },
    industry: {
      challenge: '산업별 맞춤 솔루션',
      benefit1: '물류: 스마트 창고 및 배송',
      benefit2: '제조: 유연한 생산 라인',
      benefit3: '서비스: 고객 경험 향상',
      case1: {
        company: '물류 센터',
        challenge: '피크 시즌 처리 용량 부족',
        solution: 'AMR과 인간 작업자의 협업 시스템 구축',
        result: '처리 속도 50% 향상',
        metric: '속도 향상'
      },
      case2: {
        company: '자동차 부품 제조',
        challenge: '다품종 소량 생산 대응 필요',
        solution: '협동 로봇과 숙련 작업자의 유연한 생산 시스템',
        result: '불량률 99.8% 감소',
        metric: '품질 개선'
      },
      case3: {
        company: '호텔 체인',
        challenge: '인력 부족 속 서비스 품질 유지',
        solution: '로봇이 룸서비스와 청소를, 인간이 고객 응대 담당',
        result: '운영 비용 70% 절감',
        metric: '비용 절감'
      }
    },
    contactCta: '상담 신청하기'
  },
  insights: {
    featured: {
      category: '워크포스 디자인',
      title: '2025년, 하이브리드 워크포스가 표준이 되는 이유',
      author: '김지훈 박사',
      date: '2025년 1월 15일',
      readTime: '8분 읽기'
    },
    filters: {
      all: '전체',
      workforce: '워크포스 디자인',
      case: '사례 연구',
      research: '리서치'
    },
    articles: {
      article1: {
        category: '워크포스 디자인',
        title: '인간과 로봇의 협업: 새로운 업무 모델',
        excerpt: '효과적인 하이브리드 워크포스 구축을 위한 핵심 원칙과 실전 전략을 소개합니다.',
        author: '박민수',
        date: '2025.01.10'
      },
      article2: {
        category: '기술',
        title: 'AI가 워크포스 관리를 혁신하는 방법',
        excerpt: '예측 분석과 최적화 알고리즘이 어떻게 워크포스 효율성을 극대화하는지 알아봅니다.',
        author: '이서연',
        date: '2025.01.08'
      },
      article3: {
        category: '사례 연구',
        title: '제조업의 디지털 전환 성공 사례',
        excerpt: '글로벌 제조 기업이 하이브리드 워크포스로 생산성을 40% 향상시킨 과정을 공유합니다.',
        author: '최준호',
        date: '2025.01.05'
      },
      article4: {
        category: '인사이트',
        title: '미래의 일: 인간의 역할 재정의',
        excerpt: '자동화 시대에 인간이 집중해야 할 핵심 역량과 가치에 대해 탐구합니다.',
        author: '정수진',
        date: '2025.01.03'
      },
      article5: {
        category: '물류',
        title: '스마트 물류의 미래: AMR과 인간의 조화',
        excerpt: '자율 이동 로봇이 물류 산업을 어떻게 변화시키고 있는지 살펴봅니다.',
        author: '강동욱',
        date: '2024.12.28'
      },
      article6: {
        category: '리서치',
        title: '하이브리드 워크포스의 경제적 영향',
        excerpt: '최신 연구 결과를 통해 하이브리드 워크포스의 ROI와 장기적 가치를 분석합니다.',
        author: '윤혜진',
        date: '2024.12.25'
      }
    }
  },
  careers: {
    hero: {
      title: '우리와 함께 일의 미래를 설계하세요',
      subtitle: '책임감, 디자인, 장기적 사고에 집중하는 문화에서 함께 성장하세요.',
      cta: '채용 공고 보기'
    },
    culture: {
      title: '우리의 가치',
      value1: {
        title: '장기적 사고',
        description: '우리는 단기적 성과가 아닌 지속 가능한 미래를 만듭니다.'
      },
      value2: {
        title: '책임감',
        description: '우리의 결정이 사람들의 일과 삶에 영향을 미친다는 것을 알고 있습니다.'
      },
      value3: {
        title: '디자인 우수성',
        description: '모든 것을 신중하게 설계하고, 세부 사항에 주의를 기울입니다.'
      },
      value4: {
        title: '협업',
        description: '다양한 관점과 전문성이 모여 최고의 솔루션을 만듭니다.'
      },
      value5: {
        title: '혁신',
        description: '기존의 방식에 도전하고 새로운 가능성을 탐구합니다.'
      }
    },
    openings: {
      title: '채용 중인 포지션',
      description: '직무 설명',
      requirements: '자격 요건',
      apply: '지원하기'
    },
    positions: {
      pos1: {
        title: '워크포스 아키텍트',
        department: '전략',
        location: '서울',
        description: '기업의 하이브리드 워크포스 전략을 설계하고 구현합니다. 인간, AI, 로봇의 최적 조합을 찾아 고객의 비즈니스 목표를 달성합니다.',
        requirements: '워크포스 관리 또는 조직 설계 경험 5년 이상, 전략적 사고 능력, 데이터 분석 역량'
      },
      pos2: {
        title: 'AI 엔지니어',
        department: '기술',
        location: '서울',
        description: '워크포스 최적화를 위한 AI 시스템을 개발합니다. 예측 모델, 최적화 알고리즘, 의사결정 지원 시스템을 구축합니다.',
        requirements: '머신러닝 및 AI 개발 경험 3년 이상, Python/TensorFlow 능숙, 최적화 알고리즘 이해'
      },
      pos3: {
        title: '로보틱스 엔지니어',
        department: 'BC Robotics',
        location: '서울',
        description: '산업용 로봇 시스템을 설계하고 구현합니다. AMR, Cobot 등 다양한 로봇 솔루션을 고객 환경에 맞게 최적화합니다.',
        requirements: '로보틱스 엔지니어링 경험 4년 이상, ROS 능숙, 제어 시스템 이해'
      },
      pos4: {
        title: '비즈니스 개발 매니저',
        department: '영업',
        location: '서울/싱가포르',
        description: '엔터프라이즈 고객에게 하이브리드 워크포스 솔루션을 제안하고 파트너십을 구축합니다.',
        requirements: 'B2B 영업 경험 5년 이상, 엔터프라이즈 세일즈 경험, 뛰어난 커뮤니케이션 능력'
      },
      pos5: {
        title: 'UX 디자이너',
        department: '디자인',
        location: '서울',
        description: '워크포스 관리 플랫폼의 사용자 경험을 설계합니다. 복잡한 시스템을 직관적이고 사용하기 쉽게 만듭니다.',
        requirements: 'UX 디자인 경험 3년 이상, B2B SaaS 경험 우대, Figma 능숙'
      },
      pos6: {
        title: '데이터 사이언티스트',
        department: '분석',
        location: '서울',
        description: '워크포스 데이터를 분석하여 인사이트를 도출하고 최적화 기회를 발견합니다.',
        requirements: '데이터 분석 경험 4년 이상, SQL/Python 능숙, 통계 및 머신러닝 지식'
      }
    }
  },
  contact: {
    left: {
      title: '함께 일을 재설계합시다',
      subtitle: '엔터프라이즈 솔루션 및 파트너십 문의를 환영합니다.',
      email: '이메일',
      phone: '전화',
      offices: '오피스'
    },
    seoul: {
      title: '서울',
      address: '서울특별시 강남구\n테헤란로 123\n06234'
    },
    singapore: {
      title: '싱가포르',
      address: '1 Marina Boulevard\n#20-01\nSingapore 018989'
    },
    form: {
      fullName: '이름',
      company: '회사명',
      email: '이메일',
      phone: '전화번호',
      inquiryType: '문의 유형',
      selectType: '선택하세요',
      types: {
        enterprise: '엔터프라이즈 솔루션',
        partnership: '파트너십',
        careers: '채용',
        media: '미디어',
        other: '기타'
      },
      message: '메시지',
      submit: '문의 보내기',
      privacy: '개인정보 처리방침에 동의합니다',
      success: '문의가 성공적으로 전송되었습니다. 곧 연락드리겠습니다.'
    }
  },
  footer: {
    newsletter: {
      title: '최신 소식 받기',
      description: '하이브리드 워크포스에 대한 인사이트와 업데이트를 받아보세요.',
      placeholder: '이메일 주소',
      submit: '구독'
    },
    quickLinks: {
      title: '빠른 링크'
    },
    contact: {
      title: '주소',
      address: '서울특별시 강남구 테헤란로 509 10층'
    },
    rights: '모든 권리 보유.',
    privacy: '개인정보 처리방침',
    terms: '이용약관'
  }
};
